import React from 'react';
export function ImagineSection() {
  return <section className="bg-pilates-soft py-20 px-4 sm:px-6 lg:px-8" data-id="element-161">
      <div className="max-w-4xl mx-auto text-center" data-id="element-162">
        <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-8 inline-block uppercase tracking-[0.2em]" data-id="element-163">
          IMAGINE YOUR NEXT SESSION
        </div>

        <p className="text-xl sm:text-2xl text-pilates-dark leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-164">
          Imagine opening your tablet or phone before practice and already
          knowing exactly what you're going to teach.
        </p>

        <div className="flex flex-col gap-4 font-display text-2xl sm:text-3xl text-pilates-rose mb-10" data-id="element-165">
          <p data-id="element-166">No searching.</p>
          <p data-id="element-167">No guessing.</p>
          <p data-id="element-168">No last-minute planning.</p>
          <p data-id="element-169">No stress.</p>
        </div>

        <p className="text-lg sm:text-xl text-pilates-slate leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-170">
          Just open the guide, choose your theme, and coach. Your players feel
          the intensity. You feel the difference.
        </p>

        <div className="bg-white border border-pilates-sage/20 px-6 py-5 rounded-2xl inline-block shadow-sm" data-id="element-171">
          <p className="font-display text-xl sm:text-2xl font-medium text-pilates-dark" data-id="element-172">
            For the first time in a long time...{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-173">
              your evenings belong to you again.
            </span>
          </p>
        </div>
      </div>
    </section>;
}